import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import Typography from "@mui/material/Typography";

import FindPatientForm from './FindPatientForm';
import config from "../../config/config";

const sorts = {
  '-last_seen': 'Seen Recently',
  // '-update_time': 'Seen Recently',
  '-patient__user__date_joined': 'Newest',
  'patient__user__last_name': 'Last Name (A-Z)',
  '-patient__user__last_name': 'Last Name (Z-A)',
  'patient__date_birth': 'DOB (Oldest-Youngest)',
  '-patient__date_birth': 'DOB (Youngest-Oldest)',
};

export const SortButton = props => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClose = () => setAnchorEl(null);
  return (
      <Box className="sort-button-box">
      <Stack direction='row' spacing={1} alignItems='center'>
        <Button
          id='sort-menu-btn'
          variant='grayOutline'
          aria-controls={!!anchorEl ? 'sort-menu-btn' : undefined}
          aria-haspopup='true'
          aria-expanded={!!anchorEl ? 'true' : undefined}
          onClick={e => setAnchorEl(e.currentTarget)}
          sx={{boxShadow: config().styles.defaultBoxShadow}}
        >
          <Typography variant='large500Tight' color={config().colors.gray}>
            {sorts[props.sort] || sorts['-date']}
          </Typography>
          <SwapVertIcon sx={{fontSize: '1.5rem', color: 'var(--primary)'}}/>
        </Button>
        <Menu
          id='sort-menu'
          anchorEl={anchorEl}
          open={!!anchorEl}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          disableScrollLock={true}
        >
          {
            Object.keys(sorts).map(k =>
              <MenuItem
                onClick={() => {
                  props.onChange(k);
                  handleClose();
                }}
              >
                {sorts[k]}
              </MenuItem>
            )
          }
        </Menu>
      </Stack>
    </Box>
  );
};

const PatientFilters = ({filters, onFilterChange}) => {
  return (
    <Grid container columnSpacing={3} marginBottom={{xs: 2.4, sm: 6.4}}>
      <Grid item xs={12} sm>
        <FindPatientForm
          defaultValue={filters?.id}
          sx={inputStyle}
          rounded={true}
          fullWidth={true}
          allPatients={false}
          onSubmit={({patientId}) => {
            let _filters = patientId ? {...filters, id: patientId} : omit(filters, 'id');
            onFilterChange(_filters);
          }}
        />
      </Grid>
      <Grid item sx={{display: {xs: 'none', sm: 'flex'}}} sm='auto'>
        <SortButton
          sort={filters.sort}
          onChange={sort => onFilterChange({...filters, sort})}
        />
      </Grid>
    </Grid>
  );
};

const inputStyle = {
  boxShadow: config().styles.defaultBoxShadow,
  '.MuiInputBase-root': {
    height: '38px'
  }
}

PatientFilters.propTypes = {
  filters: PropTypes.object,
  onFilterChange: PropTypes.func,
  counts: PropTypes.object,
};

export default PatientFilters;
